/* =============================================================================
 * Delta Clothing — PDP depot grid (size x warehouse matrix + customer pricing)
 *
 * Ports the storefront logic from new-ella snippets/product-page-full-width.liquid
 * (lines 1637 - 2370) into a standalone, vanilla-JS bundle that paints into a
 * <div class="b2b-depot"> hook rendered by snippets/b2b-pdp-depot.liquid.
 *
 * Responsibilities preserved verbatim:
 *
 *   1.  Fetch GET /shopify_products_depot_0?code=...&vendor=...&customer_id=...
 *   2.  Build size whitelist from the Shopify product's options_with_values.
 *   3.  Sort sizes Delta-style (XS, S, M, L, XL, 2XL, 3XL, ...) when vendor=Delta.
 *   4.  Render color swatches, size header, per-warehouse qty inputs.
 *   5.  Add-to-cart -> POST /coupon with the documented items[] shape:
 *         { variant_id, quantity, price: customer.price ?? piecePrice,
 *           properties: { Color, Variant, Warehouse, SKU, ss_sku, GTIN } }
 *   6.  Hidden Direct Ship warehouse via SHOW_DS_WAREHOUSE = false (Brand
 *       decision documented in new-ella CHANGES.md). Flip the flag to true
 *       to surface DS-only colours / sizes.
 *   7.  Scoped global fetch / XHR patcher: outbound JSON bodies that target
 *       Dash and lack SKU/GTIN get them filled in from allProducts so legacy
 *       quick-order / quick-add paths still carry the cross-reference.
 *
 * No jQuery — Stockmart already loads jQuery globally but we deliberately
 * avoid the dependency so this bundle keeps working if jQuery ever leaves.
 *
 * Depends on window.B2B (b2b-config.js).
 * =============================================================================*/
(function () {
  if (!window.B2B || window.__dlc_pdp_depot_installed) return;
  window.__dlc_pdp_depot_installed = true;

  var B2B = window.B2B;

  // Direct Ship warehouse stays hidden by default. Flip to true to surface
  // DS-only colours / sizes (e.g. Bamboo Blackout on Rabbit Skins 3326).
  // Default is false because Delta only advertises stock from physical
  // warehouses they fulfil from; DS is a separate drop-from-supplier flow.
  var SHOW_DS_WAREHOUSE = false;

  /* ---- size normalisation ---- */
  var DELTA_SIZE_ORDER = [
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "6XL",
  ];
  var SIZE_ALIAS = {
    XSMALL: "XS",
    EXTRASMALL: "XS",
    SMALL: "S",
    MEDIUM: "M",
    LARGE: "L",
    XLARGE: "XL",
    EXTRALARGE: "XL",
    XXL: "2XL",
    "2X": "2XL",
    XXXL: "3XL",
    "3X": "3XL",
    XXXXL: "4XL",
    "4X": "4XL",
    "5X": "5XL",
    "6X": "6XL",
  };

  var asArr = function (v) {
    return Array.isArray(v) ? v : [];
  };
  var norm = function (s) {
    return String(s || "")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();
  };

  /**
   * Render the qty input wrapped in a `−  [  N  ]  +` stepper. Returns
   * an HTML string suitable for use in `cell.innerHTML = …` so the
   * existing string-build flow inside `paintGrid` doesn't change.
   *
   * Operator brief (round 3): "ürün adet hücresinde oklar yerine solda −,
   * sağda + eklenecek bu alan en önemli alanımız zaten". The native
   * <input type="number"> stepper buttons are CSS-hidden; clicks on
   * our custom `.b2b-depot__qty-btn` elements run through the global
   * click handler installed at the bottom of this file, which mutates
   * the input value and re-fires the same `input` / `change` events the
   * rest of the depot logic already listens for — so cart selection,
   * line-total, and stock clamp keep working unchanged.
   */
  function renderQtyStepper(opts) {
    opts = opts || {};
    var disabled = !!opts.disabled;
    var max = opts.max != null ? opts.max : "";
    var maxAttr = max !== "" ? ' max="' + max + '"' : "";
    var dis = disabled ? " disabled" : "";
    return (
      '<div class="b2b-depot__qty-stepper' +
      (disabled ? ' b2b-depot__qty-stepper--disabled' : '') +
      '" role="group" aria-label="Quantity">' +
        '<button type="button" class="b2b-depot__qty-btn b2b-depot__qty-btn--minus" tabindex="-1" aria-label="Decrease quantity"' + dis + '>−</button>' +
        '<input type="number" class="b2b-depot__qty" value="0" min="0"' + maxAttr + dis + ' inputmode="numeric" />' +
        '<button type="button" class="b2b-depot__qty-btn b2b-depot__qty-btn--plus" tabindex="-1" aria-label="Increase quantity"' + dis + '>+</button>' +
      '</div>'
    );
  }

  // Teeland in-house SKUs: no S&S nearest-warehouse routing. OOS means
  // not orderable (Trello #64 — alternatif depo sunulmayacak).
  function isTeelandProduct(root) {
    if (!root) return false;
    var vendor = String(root.getAttribute("data-product-vendor") || "");
    var sku = String(root.getAttribute("data-product-sku") || "");
    return /teeland|delta|^1001|^te-?\d/i.test(vendor + " " + sku);
  }

  function sizeKey(sizeName) {
    var s = norm(sizeName).replace(/[\s-]/g, "");
    return SIZE_ALIAS[s] || s;
  }

  function deltaSizeRank(sizeName) {
    var idx = DELTA_SIZE_ORDER.indexOf(sizeKey(sizeName));
    return idx === -1 ? 999 : idx;
  }

  function whName(code) {
    var map = {
      KS: "Olathe, Kansas",
      TX: "Fort Worth, Texas",
      TD: "Irving (Dallas), Texas",
      GA: "McDonough, Georgia",
      NV: "Reno, Nevada",
      IL: "Lockport, Illinois",
      OH: "West Chester Township, Ohio",
      PA: "Reading, Pennsylvania",
      CC: "Bolingbrook, Illinois",
      CN: "Fresno, California",
      FO: "Orlando, Florida",
      GD: "Duluth, Georgia",
      MA: "Middleborough, Massachusetts",
      PH: "Lewisberry, Pennsylvania",
      DS: "Direct Ship (Supplier)",
    };
    return map[code] || code || "";
  }
  var WAREHOUSE_ORDER = [
    "KS",
    "TX",
    "TD",
    "GA",
    "NV",
    "IL",
    "OH",
    "PA",
    "CC",
    "CN",
    "FO",
    "GD",
    "MA",
    "PH",
    "DS",
  ];

  function money(n) {
    return "$" + (parseFloat(n) || 0).toFixed(2);
  }

  /* ---- root iteration ---- */
  function eachRoot(fn) {
    document.querySelectorAll(".b2b-depot").forEach(fn);
  }

  /* ---- size whitelist from Shopify product options ---- */
  function shopifySizeSet(root) {
    var raw = root.getAttribute("data-shopify-sizes") || "";
    var arr = raw ? raw.split("|") : [];
    var set = Object.create(null);
    arr.forEach(function (v) {
      var k = sizeKey(v);
      if (k) set[k] = true;
    });
    return set;
  }

  function isDeltaVendor(root) {
    return norm(root.getAttribute("data-product-vendor")) === "DELTA";
  }

  function filterAndSortSizes(root, sizes) {
    var allowed = shopifySizeSet(root);
    var allowedKeys = Object.keys(allowed);
    var filtered = asArr(sizes);
    if (allowedKeys.length) {
      filtered = filtered.filter(function (s) {
        var name = (s && (s.sizeName || s)) || "";
        return allowed[sizeKey(name)];
      });
    }
    if (isDeltaVendor(root)) {
      filtered = filtered
        .map(function (it, i) {
          return { it: it, i: i, r: deltaSizeRank(it && (it.sizeName || it)) };
        })
        .sort(function (a, b) {
          return a.r - b.r || a.i - b.i;
        })
        .map(function (x) {
          return x.it;
        });
    }
    return filtered;
  }

  /* ---- global state (per-root) ---- */
  function state(root) {
    if (!root.__state) {
      root.__state = {
        allProducts: [],
        depots: [],
        sizes: [],
        colors: [],
        selectedColor: "",
      };
    }
    return root.__state;
  }

  /* ---- color helpers ---- */
  function getContrastTextColor(hex) {
    if (!hex || hex.charAt(0) !== "#" || hex.length < 7) return "#fff";
    var r = parseInt(hex.substring(1, 3), 16);
    var g = parseInt(hex.substring(3, 5), 16);
    var b = parseInt(hex.substring(5, 7), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
  }

  /* ---- render ---- */
  function renderColors(root, colors, selectedColor) {
    var s = state(root);
    s.colors = colors;
    var host = root.querySelector("[data-depot-colors]");
    if (!host) return;
    host.innerHTML = "";
    asArr(colors).forEach(function (item) {
      var name = (item && item.colorName) || "";
      var hex = (item && item.color1) || "#ccc";

      // Round-3 brief: operators don't memorise vendor color codes
      // ("Comfort Colors brick", "Bella+Canvas heather mauve" — 50+
      // colors per product). Render a permanent label under each
      // swatch so they don't have to hover-and-guess. The button is
      // still the click target (same `.b2b-depot__color` selector
      // used by handleColorClick / paintSelectedColorLabel) but it
      // becomes a flex-column wrapper around three pieces:
      //   - .b2b-depot__color-dot   (the colored circle, smaller)
      //   - .b2b-depot__color-name  (hover tooltip — keeps full name
      //                              visible when the label below
      //                              gets ellipsis-truncated)
      //   - .b2b-depot__color-label (always-visible name underneath)
      var swatch = document.createElement("button");
      swatch.type = "button";
      swatch.className =
        "b2b-depot__color color-swatch" +
        (name === selectedColor ? " selected" : "");
      swatch.setAttribute("data-color", name);
      swatch.setAttribute("aria-label", name);
      swatch.setAttribute(
        "aria-pressed",
        name === selectedColor ? "true" : "false",
      );

      var dot = document.createElement("span");
      dot.className = "b2b-depot__color-dot";
      dot.style.backgroundColor = hex;
      dot.style.color = getContrastTextColor(hex);
      swatch.appendChild(dot);

      var tip = document.createElement("span");
      tip.className = "b2b-depot__color-name";
      tip.textContent = name;
      swatch.appendChild(tip);

      var label = document.createElement("span");
      label.className = "b2b-depot__color-label";
      label.textContent = name;
      label.title = name;
      swatch.appendChild(label);

      swatch.addEventListener("click", function () {
        handleColorClick(root, name);
      });
      host.appendChild(swatch);
    });
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function filterByColor(depots, colorName) {
    var target = String(colorName || "")
      .trim()
      .toLowerCase();
    return asArr(depots)
      .map(function (depot) {
        var filtered = asArr(depot.products).filter(function (p) {
          return (
            String(p.colorName || "")
              .trim()
              .toLowerCase() === target
          );
        });
        return Object.assign({}, depot, { products: filtered });
      })
      .filter(function (d) {
        return d.products.length > 0;
      });
  }

  /*
   * Brand decision (May 2026, Gildan 18000 + support@customugs.com bug):
   * a handful of colours (e.g. "Antique Cherry Red", "Safety Orange") are
   * ONLY stocked in S&S's Direct Ship lane. We hide DS at the warehouse
   * level (SHOW_DS_WAREHOUSE=false) because Delta doesn't fulfil DS
   * orders directly. Side effect: when the alphabetical first colour is
   * one of those DS-only colours, the depot grid would render with the
   * size header but ZERO warehouse rows below — looks like a broken page.
   *
   * Returns true when the colour has at least one product at a visible
   * (non-DS) warehouse — used both to pick a sensible default colour and
   * to surface the "Only Direct Ship — pick another colour" empty state.
   */
  function hasVisibleStockForColor(depots, colorName) {
    var target = String(colorName || "").trim().toLowerCase();
    if (!target) return false;
    var list = asArr(depots);
    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      var wh = d && d.warehouseAbbr;
      if (wh === "DS" && !SHOW_DS_WAREHOUSE) continue;
      var prods = asArr(d && d.products);
      for (var j = 0; j < prods.length; j++) {
        if (String(prods[j].colorName || "").trim().toLowerCase() === target) {
          return true;
        }
      }
    }
    return false;
  }

  function pickDefaultColor(depots, colors, allProducts, previous) {
    if (previous && hasVisibleStockForColor(depots, previous)) return previous;
    var colorList = asArr(colors);
    for (var i = 0; i < colorList.length; i++) {
      var name = colorList[i] && colorList[i].colorName;
      if (name && hasVisibleStockForColor(depots, name)) return name;
    }
    var all = asArr(allProducts);
    for (var k = 0; k < all.length; k++) {
      var n = all[k] && all[k].colorName;
      if (n && hasVisibleStockForColor(depots, n)) return n;
    }
    return (
      (colorList[0] && colorList[0].colorName) ||
      (all[0] && all[0].colorName) ||
      ""
    );
  }

  function paintSelectedColorLabel(root, colorName) {
    // Brand review #6: surface the selected color name inline next to the
    // "Color" heading ("Color: Black") so the persistent tooltip on the
    // selected swatch can be dropped.
    var label = root.querySelector("[data-selected-color]");
    if (label) label.textContent = colorName ? ": " + colorName : "";
  }

  function handleColorClick(root, colorName) {
    var s = state(root);
    s.selectedColor = colorName;
    root
      .querySelectorAll("[data-depot-colors] .b2b-depot__color")
      .forEach(function (el) {
        var match = el.getAttribute("data-color") === colorName;
        el.classList.toggle("selected", match);
        el.setAttribute("aria-pressed", match ? "true" : "false");
      });
    paintSelectedColorLabel(root, colorName);
    renderDepotGrid(
      root,
      filterByColor(s.depots, colorName),
      s.sizes,
      colorName,
    );
    // Let any external image-slider hook react (Stockmart has its own swiper).
    try {
      window.dispatchEvent(
        new CustomEvent("b2b:color-changed", {
          detail: { root: root, color: colorName },
        }),
      );
    } catch (e) {}
  }

  /* Brand review #4: split the warehouse table into two side-by-side
     sections when the visible warehouse count exceeds the threshold so
     the page doesn't grow unbounded vertically and the size header
     stays in view as the customer scrolls. The two sections each
     repeat the size header so the column → price mapping never gets
     ambiguous. */
  // Brand review (19 May 2026): split mode (>8 warehouses → 2 columns
  // side-by-side) was producing overlapping rows on viewports below
  // ~1500px because each row's `min-width: 100%` overflowed the half-
  // width section and bled onto the neighbouring section. Until we
  // redesign the split layout properly (each section needs its own
  // scroll context), keep the threshold high enough that real-world
  // products (≤15 warehouses) always render in single-column stacked
  // mode. Single column is taller but always readable.
  var SPLIT_THRESHOLD = 99;

  function buildSizeHeader(sizes) {
    var sizeHeader = document.createElement("div");
    sizeHeader.className = "b2b-depot__row b2b-depot__row--header";
    sizeHeader.innerHTML =
      '<div class="b2b-depot__cell b2b-depot__cell--label">Sizes</div>';
    var sizeBox = document.createElement("div");
    sizeBox.className = "b2b-depot__cells";
    sizes.forEach(function (s) {
      var c = document.createElement("div");
      c.className = "b2b-depot__cell b2b-depot__cell--size";
      c.setAttribute("data-size", s.sizeName);
      c.innerHTML =
        '<span class="b2b-depot__size">' +
        escapeHtml(s.sizeName) +
        "</span>" +
        '<span class="b2b-depot__price" data-price-cell></span>';
      sizeBox.appendChild(c);
    });
    sizeHeader.appendChild(sizeBox);
    return sizeHeader;
  }

  function renderDepotGrid(root, depots, sizes, selectedColor) {
    var grid = root.querySelector("[data-depot-grid]");
    if (!grid) return;
    grid.innerHTML = "";
    grid.classList.remove("b2b-depot__grid--split");

    if (!asArr(depots).length || !asArr(sizes).length) {
      grid.innerHTML =
        '<p class="b2b-depot__empty">No stock available for this color.</p>';
      return;
    }

    var rows = asArr(depots)
      .slice()
      .sort(function (a, b) {
        return (
          WAREHOUSE_ORDER.indexOf(a.warehouseAbbr) -
          WAREHOUSE_ORDER.indexOf(b.warehouseAbbr)
        );
      });

    var visible = rows.filter(function (d) {
      return d.warehouseAbbr !== "DS" || SHOW_DS_WAREHOUSE;
    });

    // Brand decision (May 2026): when the only stock for the chosen
    // colour sits in the DS (Direct Ship) lane — which we hide because
    // Delta doesn't fulfil DS orders directly — render an explicit
    // message instead of the misleading "size header with no rows"
    // state that support@customugs.com was hitting on Gildan 18000
    // (Antique Cherry Red is DS-only).
    if (!visible.length) {
      grid.innerHTML =
        '<p class="b2b-depot__empty">' +
        'This color is only stocked via Direct Ship and is not orderable through the panel. ' +
        'Please pick another color above or contact Delta to special-order.' +
        '</p>';
      var bar = root.querySelector("[data-depot-add]");
      if (bar) bar.setAttribute("disabled", "disabled");
      return;
    }

    var split = visible.length > SPLIT_THRESHOLD;
    var sectionsHost;

    if (split) {
      grid.classList.add("b2b-depot__grid--split");
      var leftSection = document.createElement("div");
      leftSection.className = "b2b-depot__section";
      var rightSection = document.createElement("div");
      rightSection.className = "b2b-depot__section";
      leftSection.appendChild(buildSizeHeader(sizes));
      rightSection.appendChild(buildSizeHeader(sizes));
      grid.appendChild(leftSection);
      grid.appendChild(rightSection);
      var mid = Math.ceil(visible.length / 2);
      sectionsHost = function (idx) {
        return idx < mid ? leftSection : rightSection;
      };
    } else {
      grid.appendChild(buildSizeHeader(sizes));
      sectionsHost = function () {
        return grid;
      };
    }

    var teelandProduct = isTeelandProduct(root);

    visible.forEach(function (depot, depotIdx) {
      var wh = depot.warehouseAbbr;
      var host = sectionsHost(depotIdx);

      var row = document.createElement("div");
      row.className = "b2b-depot__row";
      row.setAttribute("data-warehouse", wh);
      var label = document.createElement("div");
      label.className = "b2b-depot__cell b2b-depot__cell--label";
      label.textContent = whName(wh);
      row.appendChild(label);

      var cellsHost = document.createElement("div");
      cellsHost.className = "b2b-depot__cells";
      row.appendChild(cellsHost);

      sizes.forEach(function (sz) {
        var match = asArr(depot.products).find(function (p) {
          return norm(sz.sizeName) === norm(p.sizeName);
        });
        var cell = document.createElement("div");
        cell.className = "b2b-depot__cell";
        if (!match) {
          cell.classList.add("b2b-depot__cell--empty");
          cell.innerHTML =
            '<div class="b2b-depot__stock">Qty: 0</div>' +
            renderQtyStepper({ disabled: true });
        } else {
          var userprice =
            (match.customer && match.customer.price) != null
              ? match.customer.price
              : 0;
          var price = parseFloat(userprice || match.piecePrice || 0).toFixed(2);
          var stockQty = parseInt(match.CaseQty, 10);
          if (isNaN(stockQty)) stockQty = 0;
          var outOfStock = stockQty <= 0;

          // This warehouse has no stock — plain Qty: 0 (customer checks
          // other warehouse rows). Teeland: single depot → Out of stock.
          if (outOfStock) {
            cell.classList.add("b2b-depot__cell--empty");
            cell.innerHTML =
              '<div class="b2b-depot__stock">' +
              (teelandProduct ? "Out of stock" : "Qty: 0") +
              '</div>' +
              renderQtyStepper({ disabled: true });
            cellsHost.appendChild(cell);
            return;
          }

          cell.setAttribute("data-size", match.sizeName);
          cell.setAttribute("data-warehouse", wh);
          cell.setAttribute("data-stock", String(stockQty));
          cell.setAttribute("data-price", price);
          cell.setAttribute("data-user-price", String(userprice || 0));
          cell.setAttribute("data-ss-sku", match.ss_sku || "");
          cell.setAttribute("data-sku", match.sku || match.styleName || "");
          cell.setAttribute(
            "data-gtin",
            match.gtin || match.upc || match.barcode || "",
          );
          cell.setAttribute("data-variant-id", match.variantId || "");
          cell.innerHTML =
            '<div class="b2b-depot__stock">Qty: ' + stockQty + "</div>" +
            renderQtyStepper({ max: stockQty });

          // Header price chip fills BOTH sections in split mode — the
          // selector below scoops up every size cell with this label
          // across the grid (left + right halves).
          var headerCells = grid.querySelectorAll(
            ".b2b-depot__row--header .b2b-depot__cell--size",
          );
          headerCells.forEach(function (h) {
            if (h.getAttribute("data-size") === match.sizeName) {
              var chip = h.querySelector("[data-price-cell]");
              if (chip && !chip.textContent.trim())
                chip.textContent = money(price);
            }
          });
        }
        cellsHost.appendChild(cell);
      });

      host.appendChild(row);
    });

    // Add a sticky add-to-cart bar (one per root)
    var bar = root.querySelector("[data-depot-add]");
    if (bar) bar.removeAttribute("disabled");
  }

  /* ---- apply API payload ---- */
  function applyProductList(root, rawList) {
    if (!rawList) return;
    var s = state(root);

    if (!Array.isArray(rawList) && Array.isArray(rawList.depots)) {
      var depots = asArr(rawList.depots);
      var sizes = asArr(rawList.sizes);
      var colors = asArr(rawList.colors);

      s.depots = depots;
      s.allProducts = depots.reduce(function (acc, d) {
        return acc.concat(asArr(d.products));
      }, []);

      if (!colors.length) {
        var byColor = {};
        s.allProducts.forEach(function (p) {
          var n = p && p.colorName ? String(p.colorName) : "";
          if (!n) return;
          if (!byColor[n])
            byColor[n] = {
              colorName: n,
              color1: p.color1 || p.colorHex || "#ccc",
            };
        });
        colors = Object.keys(byColor).map(function (k) {
          return byColor[k];
        });
      }
      if (!sizes.length) {
        var bySize = {};
        s.allProducts.forEach(function (p) {
          var n = p && p.sizeName ? String(p.sizeName) : "";
          if (n && !bySize[n]) bySize[n] = { sizeName: n };
        });
        sizes = Object.keys(bySize).map(function (k) {
          return bySize[k];
        });
      }

      sizes = filterAndSortSizes(root, sizes);
      s.sizes = sizes;

      // Skip DS-only colours when picking the auto-selected default so
      // the depot grid never lands on an empty (visible=0) state on
      // first paint. Customers can still pick a DS-only colour
      // manually — they'll see the explicit message rendered below.
      var firstColor = pickDefaultColor(depots, colors, s.allProducts, s.selectedColor);
      s.selectedColor = firstColor;

      renderColors(root, colors, firstColor);
      paintSelectedColorLabel(root, firstColor);
      renderDepotGrid(
        root,
        filterByColor(s.depots, firstColor),
        s.sizes,
        firstColor,
      );
    } else if (Array.isArray(rawList)) {
      // Legacy flat-list shape (Teeland-only). Build a synthetic single-depot
      // so the same UI works without a second renderer.
      var arr = asArr(rawList);
      var byWh = { _flat: { warehouseAbbr: "KS", products: arr } };
      var fakeSizes = [];
      var seen = {};
      arr.forEach(function (p) {
        if (p && p.sizeName && !seen[p.sizeName]) {
          seen[p.sizeName] = true;
          fakeSizes.push({ sizeName: p.sizeName });
        }
      });
      applyProductList(root, {
        depots: [byWh._flat],
        sizes: fakeSizes,
        colors: [],
      });
    }
  }

  /* ---- fetch ---- */
  function bootstrapRoot(root) {
    var sku = root.getAttribute("data-product-sku") || "";
    var vendor = root.getAttribute("data-product-vendor") || "";
    var cust = B2B.getCustomerId() || "0";
    if (!sku) return;
    var url =
      B2B.endpoints.depot +
      "?code=" +
      encodeURIComponent(sku) +
      "&vendor=" +
      encodeURIComponent(vendor) +
      "&customer_id=" +
      encodeURIComponent(cust) +
      "&t=" +
      Date.now();
    fetch(url, { method: "GET", headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list = data && data.list;
        if (!list) return;
        applyProductList(root, list);
      })
      .catch(function (err) {
        console.error("[b2b-depot] fetch failed", err);
      });
  }

  /* ---- add to cart ---- */
  function gatherSelection(root) {
    var s = state(root);
    var lines = [];
    root
      .querySelectorAll("[data-depot-grid] .b2b-depot__cell[data-size]")
      .forEach(function (cell) {
        var input = cell.querySelector(".b2b-depot__qty");
        if (!input) return;
        var qty = parseInt(input.value || "0", 10);
        if (!qty || qty < 1) return;
        var size = cell.getAttribute("data-size");
        var wh = cell.getAttribute("data-warehouse");
        var price = parseFloat(cell.getAttribute("data-price")) || 0;
        var ssSku = cell.getAttribute("data-ss-sku") || "";
        var sku = cell.getAttribute("data-sku") || "";
        var gtin = cell.getAttribute("data-gtin") || "";
        var vid =
          cell.getAttribute("data-variant-id") ||
          matchVariantBySize(root, size);
        lines.push({
          variant_id: vid
            ? "gid://shopify/ProductVariant/" + String(vid).replace(/\D/g, "")
            : "",
          quantity: qty,
          price: price,
          ss_sku: ssSku || undefined,
          properties: {
            Color: s.selectedColor || "",
            Variant: size,
            Warehouse: wh,
            SKU: sku || undefined,
            ss_sku: ssSku || undefined,
            GTIN: gtin || undefined,
          },
        });
      });
    return lines;
  }

  function matchVariantBySize(root, size) {
    try {
      var variants = JSON.parse(root.getAttribute("data-variants") || "[]");
      var key = sizeKey(size);
      var v = variants.find(function (vr) {
        if (!vr) return false;
        var candidates = [vr.title, vr.option1, vr.option2, vr.option3].filter(
          Boolean,
        );
        return candidates.some(function (c) {
          return (
            sizeKey(c) === key || sizeKey(String(c).split("/").pop()) === key
          );
        });
      });
      return v ? String(v.id) : "";
    } catch (e) {
      return "";
    }
  }

  function addSelectionToCart(root) {
    var cust = B2B.getCustomerGid();
    if (!cust) {
      window.location.href = "/account/login";
      return;
    }
    var cartAdd = window.DLC && window.DLC.cartAdd;
    var color =
      (root.querySelector("[data-selected-color]") &&
        root.querySelector("[data-selected-color]").textContent) ||
      "";
    color = String(color || "").trim();
    if (!color) {
      var colorMsg = "Please select a color before adding to cart.";
      if (cartAdd) cartAdd.showError(colorMsg, root);
      else alert(colorMsg);
      return;
    }
    var items = gatherSelection(root);
    if (!items.length) {
      var msg = "Please enter a quantity before adding to cart.";
      if (cartAdd) cartAdd.showError(msg, root);
      else alert(msg);
      return;
    }
    var btn = root.querySelector("[data-depot-add]");
    if (btn) {
      btn.setAttribute("disabled", "disabled");
      btn.classList.add("is-loading");
    }

    B2B.postJSON(B2B.endpoints.coupon, { customer_id: cust, items: items })
      .then(function (resp) {
        if (btn) {
          btn.removeAttribute("disabled");
          btn.classList.remove("is-loading");
        }
        if (!resp || resp.error) {
          var err =
            (resp && (resp.message || resp.error)) ||
            "Could not add to cart. Please try again.";
          if (cartAdd) cartAdd.showError(err, root);
          else alert(err);
          return;
        }
        // Reset quantity inputs
        root.querySelectorAll(".b2b-depot__qty").forEach(function (i) {
          i.value = "0";
        });
        try {
          if (typeof window.setBagCountFromResponse === "function")
            window.setBagCountFromResponse(resp);
        } catch (e) {}
        try {
          window.dispatchEvent(
            new CustomEvent("dlc:cart-changed", { detail: resp }),
          );
        } catch (e) {}

        // Visual confirmation
        var msg = root.querySelector("[data-depot-msg]");
        if (msg) {
          msg.textContent = "Added to your cart.";
          msg.classList.add("is-success");
          setTimeout(function () {
            msg.textContent = "";
            msg.classList.remove("is-success");
          }, 3500);
        }

        // If cart drawer is enabled, open it after a tick
        try {
          if (window.cartDrawer && typeof window.cartDrawer.open === "function")
            window.cartDrawer.open();
          var drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.open === "function") drawer.open();
        } catch (e) {}
      })
      .catch(function () {
        if (btn) {
          btn.removeAttribute("disabled");
          btn.classList.remove("is-loading");
        }
        alert("Could not add to cart. Please try again.");
      });
  }

  document.addEventListener("click", function (e) {
    var btn =
      e.target && e.target.closest && e.target.closest("[data-depot-add]");
    if (!btn) return;
    var root = btn.closest(".b2b-depot");
    if (!root) return;
    e.preventDefault();
    addSelectionToCart(root);
  });

  // Clamp to on-hand at this warehouse (OOS cells are disabled).
  document.addEventListener("input", function (e) {
    var inp =
      e.target && e.target.closest && e.target.closest(".b2b-depot__qty");
    if (!inp) return;
    var cell = inp.closest(".b2b-depot__cell");
    if (!cell) return;
    var max = parseInt(cell.getAttribute("data-stock") || "0", 10);
    var v = parseInt(inp.value || "0", 10);
    if (isNaN(v) || v < 0) v = 0;
    if (max > 0 && v > max) v = max;
    if (String(v) !== inp.value) inp.value = String(v);
  });

  /* ---- Custom −/+ stepper buttons ----
   * Operator brief: native <input type=number> stepper arrows are
   * impossible to hit on touch + B2B operators add to cart all day, so
   * we replace them with explicit "−" / "+" buttons that flank the
   * input. Click → adjust value, dispatch the same `input` + `change`
   * events the rest of the depot logic listens for (clamp, total,
   * cart-pick), so this is purely an input-mechanism swap. */
  document.addEventListener("click", function (e) {
    var btn =
      e.target &&
      e.target.closest &&
      e.target.closest(".b2b-depot__qty-btn");
    if (!btn) return;
    if (btn.disabled) return;
    var stepper = btn.closest(".b2b-depot__qty-stepper");
    if (!stepper) return;
    var input = stepper.querySelector(".b2b-depot__qty");
    if (!input || input.disabled) return;
    e.preventDefault();
    var max = parseInt(input.getAttribute("max") || "0", 10);
    var cur = parseInt(input.value || "0", 10);
    if (isNaN(cur) || cur < 0) cur = 0;
    var delta = btn.classList.contains("b2b-depot__qty-btn--plus") ? 1 : -1;
    var next = cur + delta;
    if (next < 0) next = 0;
    if (max > 0 && next > max) next = max;
    if (next === cur) return;
    input.value = String(next);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---- scoped fetch / XHR patcher (SKU + GTIN injection) ----
   * Only mutates JSON bodies bound for dash.deltaclothing.com. Outbound
   * Shopify Admin, predictive search, Section Rendering, gift-card recipient
   * form, etc. are never touched.
   */
  (function installSkuPatcher() {
    if (window.__skuGtinDraftPatchInstalled) return;
    window.__skuGtinDraftPatchInstalled = true;

    function findExtra(color, size) {
      var found = null;
      var c = norm(color);
      var sz = norm(size);
      if (!c || !sz) return null;
      document.querySelectorAll(".b2b-depot").forEach(function (root) {
        var st = state(root);
        if (found) return;
        var item = (st.allProducts || []).find(function (p) {
          return (
            norm(p && (p.colorName || p.color)) === c &&
            norm(p && (p.sizeName || p.size)) === sz
          );
        });
        if (item) {
          var sku = item.sku || item.styleName || "";
          var gtin = item.gtin || item.upc || item.barcode || "";
          if (sku || gtin) found = { sku: sku, gtin: gtin };
        }
      });
      return found;
    }

    function injectInto(lineItem) {
      if (!lineItem) return;
      var props = lineItem.properties || {};
      var color, size;
      if (Array.isArray(props)) {
        props.forEach(function (p) {
          if (!p || typeof p.name === "undefined") return;
          var n = norm(p.name);
          if (!color && n === "COLOR") color = p.value;
          if (!size && (n === "VARIANT" || n === "SIZE")) size = p.value;
        });
      } else if (props && typeof props === "object") {
        color = props.Color || props.color;
        size = props.Variant || props.Size || props.size;
      }
      var extra = findExtra(color, size);
      if (!extra) return;
      if (Array.isArray(props)) {
        function ensure(name, value) {
          if (!value) return;
          var exists = props.some(function (p) {
            return p && p.name === name;
          });
          if (!exists) props.push({ name: name, value: String(value) });
        }
        ensure("SKU", extra.sku);
        ensure("GTIN", extra.gtin);
        lineItem.properties = props;
      } else if (props && typeof props === "object") {
        if (extra.sku && !props.SKU) props.SKU = String(extra.sku);
        if (extra.gtin && !props.GTIN) props.GTIN = String(extra.gtin);
        lineItem.properties = props;
      }
    }

    function patchData(data) {
      if (!data || typeof data !== "object") return;
      if (Array.isArray(data)) data.forEach(injectInto);
      else if (Array.isArray(data.items)) data.items.forEach(injectInto);
      else if (Array.isArray(data.lines)) data.lines.forEach(injectInto);
      else if (Array.isArray(data.line_items))
        data.line_items.forEach(injectInto);
      else injectInto(data);
    }

    function patchBody(body) {
      if (typeof body !== "string") return body;
      var trimmed = body.trim();
      if (!trimmed) return body;
      var first = trimmed.charAt(0);
      if (first !== "{" && first !== "[") return body;
      try {
        var data = JSON.parse(trimmed);
        patchData(data);
        return JSON.stringify(data);
      } catch (e) {
        return body;
      }
    }

    function isDashUrl(input) {
      try {
        var url = "";
        if (typeof input === "string") url = input;
        else if (input && input.url) url = input.url;
        if (!url) return false;
        return /(^|\/\/)dash\.deltaclothing\.com\b/.test(url);
      } catch (e) {
        return false;
      }
    }

    if (window.fetch) {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        if (isDashUrl(input) && init && typeof init.body === "string") {
          init = Object.assign({}, init, { body: patchBody(init.body) });
        }
        return _fetch.call(this, input, init);
      };
    }

    if (window.XMLHttpRequest) {
      var _open = XMLHttpRequest.prototype.open;
      var _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__dlc_target_dash = /(^|\/\/)dash\.deltaclothing\.com\b/.test(
          String(url || ""),
        );
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        if (this.__dlc_target_dash && typeof body === "string")
          body = patchBody(body);
        return _send.call(this, body);
      };
    }
  })();

  /* ---- init ---- */
  function init() {
    eachRoot(bootstrapRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    setTimeout(init, 0);
  }

  // Re-bootstrap if Shopify Section Rendering swaps in a new PDP section
  document.addEventListener("shopify:section:load", function (ev) {
    if (!ev.target) return;
    ev.target.querySelectorAll(".b2b-depot").forEach(bootstrapRoot);
  });
})();
